import { HTTPError } from 'ky';

import type { IAuthResponse, IPortalUser } from '../types';
import apiClient from './apiClient';

// Normalize ky's HTTPError into the { response: { data } } shape that UI components expect
const parseHttpError = async (error: unknown): Promise<never> => {
  if (error instanceof HTTPError) {
    const body = (await error.response.json().catch(() => ({}))) as any;
    throw Object.assign(new Error(body.message || 'Request failed'), {
      response: { data: body, status: error.response.status },
    });
  }
  throw error;
};

export const login = async (email: string, password: string): Promise<IAuthResponse> => {
  return apiClient
    .post('auth/login', { json: { email, password } })
    .json<{ data: IAuthResponse }>()
    .then((res) => res.data)
    .catch(parseHttpError);
};

export const getMe = async (signal?: AbortSignal): Promise<IPortalUser> => {
  return apiClient
    .get('me', { signal })
    .json<{ data: IPortalUser }>()
    .then((res) => res.data);
};

export const resetPassword = async (newPassword: string): Promise<void> => {
  await apiClient.post('auth/reset-password', { json: { newPassword } }).catch(parseHttpError);
};
